import layout from '../../../mixins/layout'

export default {
  mixins: [layout],

  props: {
    breadcrumbList: Array,
    linkList: Array,
    socialLanguage: Object,
    availableLocales: Array,
    exclusiveUrlLocales: Array,
    localeTitle: String,
    endLinks: Array,
    hotmartRights: String,
    hotmartAddress: String,
    changeRoute: Function,
  },

  data() {
    return {
      isMobile: this.isMobile,
    }
  },
}
